export const ONBOARDING_NEW_USER_ROUTE = 'new-user';
export const ONBOARDING_WELCOME_INDUSTRY_ROUTE = 'welcome-industry';
export const ONBOARDING_EXISTING_USER_ROUTE = 'existing-user';
export const ONBOARDING_OAUTH_TOKEN_QUERY_PARAM = 'oauth_token';
export const ONBOARDING_READY_ROUTE = 'ready';

export function getOnboardingInvoiceOptionsCompletedKey(accountId: string) {
  return `onboarding_invoice_options_completed_${accountId}`;
}

export function getOauthTokenKey(accountId: string) {
  return `onboarding_oauth_token_${accountId}`;
}

export enum AccountRoleEnum {
  full_access = 'full_access',
  limited_access = 'limited_access',
}
